// benchmarks-store.jsx
import { createContext, useContext, useEffect, useState } from "react";

const BenchmarksCtx = createContext(null);
export const useBenchmarks = () => useContext(BenchmarksCtx);

export function BenchmarksProvider({ children }) {
  const [categoryData, setCategoryData] = useState(null);
  const [supplierData, setSupplierData] = useState(null);

  // optional: hydrate from sessionStorage so data survives refresh
  useEffect(() => {
    const c = sessionStorage.getItem("categoryData");
    const s = sessionStorage.getItem("supplierData");
    if (c) setCategoryData(JSON.parse(c));
    if (s) setSupplierData(JSON.parse(s));
  }, []);

  useEffect(() => {
    if (categoryData) sessionStorage.setItem("categoryData", JSON.stringify(categoryData));
  }, [categoryData]);

  useEffect(() => {
    if (supplierData) sessionStorage.setItem("supplierData", JSON.stringify(supplierData));
  }, [supplierData]);

  return (
    <BenchmarksCtx.Provider value={{ categoryData, supplierData, setCategoryData, setSupplierData }}>
      {children}
    </BenchmarksCtx.Provider>
  );
}
